import { Tag } from 'antd';
import styled from 'styled-components';
import { getColor } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
export var ClassStatusTag = function ClassStatusTag(_ref) {
  var status = _ref.status,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? {
    active: 'Active',
    archived: 'Archived'
  } : _ref$labels;
  return /*#__PURE__*/_jsx(Tag, {
    color: status === 'ACTIVE' ? 'green' : 'default',
    children: status === 'ACTIVE' ? labels.active : labels.archived
  });
};
var CoverStatusPill = styled.span.withConfig({
  displayName: "class-statuscomponent__CoverStatusPill",
  componentId: "sc-9g6ns4-0"
})(["position:absolute;top:12px;left:12px;z-index:1;display:inline-flex;align-items:center;max-width:calc(100% - 60px);padding:5px 10px;border-radius:999px;font-size:12px;font-weight:800;line-height:1.2;letter-spacing:0.04em;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:", ";background:rgba(255,255,255,0.94);border:1px solid rgba(255,255,255,0.8);box-shadow:0 1px 3px rgba(28,30,32,0.1);"], function (props) {
  return props.$active ? '#15803d' : getColor('textIntSub');
});
export var ClassStatusCoverTag = function ClassStatusCoverTag(_ref2) {
  var status = _ref2.status,
      _ref2$labels = _ref2.labels,
      labels = _ref2$labels === void 0 ? {
    active: 'Active',
    archived: 'Archived'
  } : _ref2$labels;
  return /*#__PURE__*/_jsx(CoverStatusPill, {
    $active: status === 'ACTIVE',
    children: status === 'ACTIVE' ? labels.active : labels.archived
  });
};